import React, { useState, useEffect } from 'react';
import { Modal, ModalBody, Button } from 'reactstrap';
import { connect } from 'react-redux';
import { getAuthUser, getAuthProgram } from "@/containers/App/auth";
const authProgram = getAuthProgram();
const PromoBannerModal = () => {
  const [showModal, setShowModal] = useState(false);
  const [showPin, setShowPin] = useState(false);
  const IMG_PROMO_BANNER = `${process.env.REACT_APP_API_STORAGE_URL}/theme/default/images/ICORewards_Promo_Banner.jpg`;
  const IMG_PROMO_ICON = `${process.env.REACT_APP_API_STORAGE_URL}/theme/default/images/ICORewards_icon1.png`;
  // ✅ Check localStorage to control visibility
    useEffect(() => {
        const promoClosed = localStorage.getItem('promo_closed');

        if (authProgram?.template?.show_promo_banner) {
            if (!promoClosed) {
                setShowModal(true);
            } else {
                setShowPin(true);
            }
        }
    }, [authProgram]);
    // ✅ Close modal & set localStorage
    const handleClose = () => {
        setShowModal(false);
        setShowPin(true);
        localStorage.setItem('promo_closed', 'true');
    };

    // ✅ Reopen modal & clear localStorage
    const handleOpen = () => {
        setShowModal(true);
        setShowPin(false);
        localStorage.removeItem('promo_closed');
    };
    return (
        <>
            {/* 📌 Pinned Button (bottom-right) */}
            {showPin && (
            <div className="promo-pin" onClick={handleOpen}>
                <img
                src={IMG_PROMO_ICON}
                alt="Open Promo"
                />
            </div>
            )}

            {/* 🪄 Modal */}
            <Modal isOpen={showModal} toggle={handleClose} centered className="promo-banner-modal" modalClassName="promo-modal">
                <div className="promo-close" onClick={handleClose}>×</div>

                <ModalBody className="p-0 position-relative">
                    {IMG_PROMO_BANNER ? (
                    <img
                        src={IMG_PROMO_BANNER}
                        alt="Promo Banner"
                        className="img-fluid w-100"
                        style={{ borderRadius: '8px 8px 0 0' }}
                    />
                    ) : (
                    <div className="p-4 text-center bg-primary text-white">
                        <h4>🎉 Special Promotion!</h4>
                        <p>Don't miss out on our latest offers.</p>
                    </div>
                    )}

                </ModalBody>
            </Modal>
        </>
    );
};

const mapStateToProps = (state) => ({
  program: state.program,
});

export default connect(mapStateToProps)(PromoBannerModal);